export default ({ itemList = [], totalQuantity = 0, total = 0 }) => ({
  itemList,
  totalQuantity,
  total,
  length: 0,
  updated: false,
});
